<template lang="pug">
span(:class="{ '__error': vError }")
  label(v-if="label", :for="name").__form-label {{ label }}
  textarea.__form-textarea(
    v-if="isText"
    :class="classes"
    v-bind="$options.propsData"
    @input="text($event)"
    @blur="blur($event)"
  )
  .text(v-if="vError") {{ errorText }}
  slot
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: '',
    },

    label: {
      type: String,
      default: '',
    },

    resize: {
      type: String,
      default: '',
    },

    errorText: {
      type: String,
      default: '',
    },

    placeholder: {
      type: String,
      default: '',
    },

    value: {
      type: [String, Number],
      default: '',
    },

    rows: {
      type: Number,
      default: null,
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    isText: {
      type: Boolean,
      default: true,
    },

    error: {
      type: [String, Boolean],
      default: '',
    },

    v: {
      type: [Object, Function],
      default: null,
    },
  },

  computed: {
    vError() {
      return this.error || (this.v && this.v.$error);
    },

    classes() {
      return {
        [`resize_${this.resize}`]: true,
        'fixed-height': !this.rows,
      };
    },
  },

  methods: {
    text($event) {
      if (this.v) {
        this.v.$touch();
      }
      this.$emit('input', $event.target.value);
    },

    blur($event) {
      if (this.v) {
        this.v.$touch();
      }
      this.$emit('blur', $event);
    },
  },
};
</script>

<style lang="stylus" scoped>
.__form-label
  color #252525
  display block
  font-size 10px
  line-height 1.4
  text-transform uppercase
  font-family 'Open Sans', sans-serif
  margin-bottom 8px
  text-align left

.__form-textarea.fixed-height
  height 36px
  line-height 34px
  padding 0px 10px

.__form-textarea
  padding 5px 10px
  width 100%
  font-family 'Open Sans', sans-serif
  display inline-block
  vertical-align middle
  font-size 14px
  line-height 20px
  color: rgba(0, 0, 0, 0.85)
  text-overflow ellipsis
  background-color #fff
  border-radius 2px
  border 1px solid #cfd4d8
  box-shadow inset 2px 2px 8px rgba(0, 0, 0, 0.1)
  transition all 0.3s ease-in-out

  &::-webkit-input-placeholder
    font-family 'Open Sans', sans-serif
    text-transform uppercase
    font-size 11px
    color #9e9e9e

  &:focus, &:active
    outline none
    border-color #09f !important

  &:hover
    border 1px solid #a5aeb5
    box-shadow inset 2px 2px 8px rgba(0, 0, 0, 0.15)

  &.resize_none
    resize none

.__error
  .__form-textarea
    color red
    border-color red

    &::-webkit-input-placeholder
      color red

  .text
    color red
    font-size 0.75em
    position absolute
</style>



// WEBPACK FOOTER //
// Textarea.vue?ae83db16